// src/menu/sections/iamMenu.ts
import type { AppMenuEntry } from "../types";

export const IAM_MENU: AppMenuEntry = {
  type: "group",
  key: "iam",
  label: "IAM",
  children: [
    { key: "users", label: "Users", path: "/users", resource: "users", icon: "useraddoutlined" },
    { key: "groups", label: "Groups", path: "/groups", resource: "groups", icon: "usergroupadd" },
    {
      key: "group_shares",
      label: "Group Shares",
      path: "/group_shares",
      resource: "group_shares",
      icon: "sharealt",
    },
  ],
};
